export const MenuSet = [
    "Job Positions",
    // "Match Analysis",
    "Applications",
    "Match Analysis",
    // "Dashboard"

    // "Job Positions List",
    // "Settings"
  ];